export default __webpack_public_path__ + "8d0437501ed25845d19be2439a3b28ee.jpg";